export const blockIconsTextformattingListAltNew = (
	<span className='material-symbols-outlined'>list_alt</span>
);
